export default __webpack_public_path__ + "a97d526a711b93d2fe4b1f72dd9148ea.png";